export default __webpack_public_path__ + "static/media/single-staggered-border-right.442c2201.svg";